import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ScheduleInterviewApplicationFragment } from 'generated/resources/graphql'

import { ApplicationPhaseTag } from '../ApplicationPhaseTag'

interface Props {
  application: ScheduleInterviewApplicationFragment
}

export const ApplicationCard = ({ application }: Props) => {
  return (
    <Box
      flexDirection="row"
      gap="s16"
      padding="s16"
      alignItems="center"
      borderRadius={{ all: 'abs008' }}
      border={{ all: { style: 'solid', width: 's1', color: 'grey400' } }}
    >
      <Avatar size="s64" url={application.photoThumbnail} label={application.candidate.fullName} />
      <Box gap="s8" width="full">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Normal weight="semibold">{application.candidate.fullName}</Text.Normal>
          <ApplicationPhaseTag applicationPhase={application.applicationPhase} />
        </Box>
        <Box flexDirection="row" gap="s8">
          <Text.Normal weight="semibold">{application.jobPosting.title}</Text.Normal>
          {application.jobPosting.location && (
            <Text.Normal> en {application.jobPosting.location.name}</Text.Normal>
          )}
        </Box>
      </Box>
    </Box>
  )
}
